var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "confirmation" }, [
    _c("div", { staticClass: "gradient-panel" }, [
      _c("div", { staticClass: "content-area" }, [
        _c("div", { staticClass: "callout" }, [
          _c("h4", { staticClass: "success-title" }, [
            _c("i", { staticClass: "material-icons check-circle" }, [
              _vm._v("check_circle")
            ]),
            _vm._v(" " + _vm._s(_vm.strings.paymentSuccessful) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "divider" }),
          _vm._v(" "),
          _c("div", { staticClass: "success-body" }, [
            _vm._v("\n          " + _vm._s(_vm.strings.amount) + " "),
            _c(
              "span",
              { staticClass: "semibold", attrs: { id: "paymentAmount" } },
              [
                _vm._v(
                  _vm._s(
                    _vm._f("currency")(
                      _vm.paymentResource.paymentDetails.amount
                    )
                  )
                )
              ]
            ),
            _vm._v("\n          " + _vm._s(_vm.strings.submitted) + " "),
            _c(
              "span",
              { staticClass: "semibold", attrs: { id: "policyNumber" } },
              [_vm._v(_vm._s(_vm.paymentResource.policyNumber))]
            ),
            _vm._v(
              ".\n          " + _vm._s(_vm.strings.transactionNumber) + " "
            ),
            _c("span", { staticClass: "semibold" }, [
              _vm._v(_vm._s(_vm.paymentResource.gateway.transactionId))
            ]),
            _vm._v(".\n          " + _vm._s(_vm.strings.delay) + "\n        ")
          ])
        ]),
        _vm._v(" "),
        _vm.insuranceIsSfi
          ? _c("div", { staticClass: "grid-x sfi-insurance" }, [
              _c("div", { staticClass: "cell small-12 medium-8" }, [
                _c("h3", [_vm._v(_vm._s(_vm.strings.sfiCobrand.title))]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "ul",
                    _vm._l(_vm.strings.sfiCobrand.details, function(
                      listItem,
                      name,
                      index
                    ) {
                      return _c("li", { key: index }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(listItem) +
                            "\n              "
                        )
                      ])
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "button primary-orange expanded-for-small-only sfi-sign-up-btn",
                    on: { click: _vm.signUpBtn }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.strings.sfiCobrand.signUpText) +
                        "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell hide-for-small-only medium-4" }, [
      _c("img", { attrs: { src: require("@/assets/flamingos-rule.svg") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-648a0436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648a0436","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirmation.vue
// module id = null
// module chunks = 